class FeaturedProductBlockSection extends HTMLElement {
  constructor() {
    super();    

    this.querySelectorAll('.icon__text__block').forEach((inputIconBlock) => {  
        inputIconBlock.addEventListener('click', (event) => {
        //event.preventDefault();
        var get_tab_click = inputIconBlock.getAttribute("data-tab-nav-index");            
    
                //alert("Not active");
                document.querySelectorAll('.icon__text__block').forEach((navIconBlock) => {  
                    navIconBlock.classList.remove("active");            
                });
                inputIconBlock.classList.add("active");        

        });
    });


  }
}

customElements.define('featured-product-block-section', FeaturedProductBlockSection);